import { getRequest, postRequest } from "../../../api/api";

export function getKnowledgeTestQuestions(callbackResponse) {
    return getRequest(
        'api/v1/wallet/fetch-knowledge-questions',
        null,
        callbackResponse
    );
};

export function postSubmitKnowledgeTest(values, callbackResponse) {
    return postRequest(
        'api/v1/wallet/save-knowledge-test',
        null,
        values,
        callbackResponse,
    );
};